export default __webpack_public_path__ + "static/media/sound-effect-key-visual.c5ce610e.svg";